import { Collapse as AntdCollapse, CollapseProps } from 'antd'

export const Collapse = (props: CollapseProps) => <AntdCollapse {...props} />
